import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import {
  DashboardCardComponent,
  DashboardCardHeaderActionsDirective,
} from '@catch/general-ui';
import { faClipboardList } from '@fortawesome/pro-light-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { PlatformDashboardService } from '../../../../services/platform-dashboard.service';
import { PlatformDashboardTaskItemComponent } from '../dashboard-task-item/platform-dashboard-task-item.component';

@Component({
  selector: 'app-platform-dashboard-tasks',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DashboardCardComponent,
    DashboardCardHeaderActionsDirective,
    TranslocoPipe,
    PlatformDashboardTaskItemComponent,
  ],
  templateUrl: './platform-dashboard-tasks.component.html',
  styleUrl: './platform-dashboard-tasks.component.scss',
})
export class PlatformDashboardTasksComponent {
  readonly dashboard = inject(PlatformDashboardService);
  readonly openChoice = output<number>();
  readonly icons = {
    clipboardList: faClipboardList,
  };
}
